export const TEST_PDPS = {
  'womens-tree-runners': [
    { text: 'Womens', href: '/products/womens-tree-runners', handle: 'womens-tree-runners' },
    { text: 'Mens', href: '/products/mens-tree-runners', handle: 'mens-tree-runners' },
  ],
  'mens-tree-runners': [
    { text: 'Womens', href: '/products/womens-tree-runners', handle: 'womens-tree-runners' },
    { text: 'Mens', href: '/products/mens-tree-runners', handle: 'mens-tree-runners' },
  ],
  'womens-wool-runners': [
    { text: 'Womens', href: '/products/womens-wool-runners', handle: 'womens-wool-runners' },
    { text: 'Mens', href: '/products/mens-wool-runners', handle: 'mens-wool-runners' },
  ],
  'mens-wool-runners': [
    { text: 'Womens', href: '/products/womens-wool-runners', handle: 'womens-wool-runners' },
    { text: 'Mens', href: '/products/mens-wool-runners', handle: 'mens-wool-runners' },
  ],
  'womens-tree-loungers': [
    { text: 'Womens', href: '/products/womens-tree-loungers', handle: 'womens-tree-loungers' },
    { text: 'Mens', href: '/products/mens-tree-loungers', handle: 'mens-tree-loungers' },
  ],
  'mens-tree-loungers': [
    { text: 'Womens', href: '/products/womens-tree-loungers', handle: 'womens-tree-loungers' },
    { text: 'Mens', href: '/products/mens-tree-loungers', handle: 'mens-tree-loungers' },
  ],
  'womens-tree-pipers': [
    { text: 'Womens', href: '/products/womens-tree-pipers', handle: 'womens-tree-pipers' },
    { text: 'Mens', href: '/products/mens-tree-pipers', handle: 'mens-tree-pipers' },
  ],
  'mens-tree-pipers': [
    { text: 'Womens', href: '/products/womens-tree-pipers', handle: 'womens-tree-pipers' },
    { text: 'Mens', href: '/products/mens-tree-pipers', handle: 'mens-tree-pipers' },
  ],
  'womens-wool-runner-mizzles': [
    {
      text: 'Womens',
      href: '/products/womens-wool-runner-mizzles',
      handle: 'womens-wool-runner-mizzles',
    },
    {
      text: 'Mens',
      href: '/products/mens-wool-runner-mizzles',
      handle: 'mens-wool-runner-mizzles',
    },
  ],
  'mens-wool-runner-mizzles': [
    {
      text: 'Womens',
      href: '/products/womens-wool-runner-mizzles',
      handle: 'womens-wool-runner-mizzles',
    },
    {
      text: 'Mens',
      href: '/products/mens-wool-runner-mizzles',
      handle: 'mens-wool-runner-mizzles',
    },
  ],
  'womens-wool-loungers': [
    { text: 'Womens', href: '/products/womens-wool-loungers', handle: 'womens-wool-loungers' },
    { text: 'Mens', href: '/products/mens-wool-loungers', handle: 'mens-wool-loungers' },
  ],
  'mens-wool-loungers': [
    { text: 'Womens', href: '/products/womens-wool-loungers', handle: 'womens-wool-loungers' },
    { text: 'Mens', href: '/products/mens-wool-loungers', handle: 'mens-wool-loungers' },
  ],
  'womens-wool-dasher-mizzles': [
    {
      text: 'Womens',
      href: '/products/womens-wool-dasher-mizzles',
      handle: 'womens-wool-dasher-mizzles',
    },
    {
      text: 'Mens',
      href: '/products/mens-wool-dasher-mizzles',
      handle: 'mens-wool-dasher-mizzles',
    },
  ],
  'mens-wool-dasher-mizzles': [
    {
      text: 'Womens',
      href: '/products/womens-wool-dasher-mizzles',
      handle: 'womens-wool-dasher-mizzles',
    },
    {
      text: 'Mens',
      href: '/products/mens-wool-dasher-mizzles',
      handle: 'mens-wool-dasher-mizzles',
    },
  ],
  'womens-trail-runners-swt': [
    {
      text: 'Womens',
      href: '/products/womens-trail-runners-swt',
      handle: 'womens-trail-runners-swt',
    },
    { text: 'Mens', href: '/products/mens-trail-runners-swt', handle: 'mens-trail-runners-swt' },
  ],
  'mens-trail-runners-swt': [
    {
      text: 'Womens',
      href: '/products/womens-trail-runners-swt',
      handle: 'womens-trail-runners-swt',
    },
    { text: 'Mens', href: '/products/mens-trail-runners-swt', handle: 'mens-trail-runners-swt' },
  ],
  'womens-tree-dashers': [
    {
      text: 'Womens',
      href: '/products/womens-tree-dashers',
      handle: 'womens-tree-dashers',
    },
    { text: 'Mens', href: '/products/mens-tree-dashers', handle: 'mens-tree-dashers' },
  ],
  'mens-tree-dashers': [
    {
      text: 'Womens',
      href: '/products/womens-tree-dashers',
      handle: 'womens-tree-dashers',
    },
    { text: 'Mens', href: '/products/mens-tree-dashers', handle: 'mens-tree-dashers' },
  ],
  'smallbirds-wool-runners-little-kids': [
    {
      text: 'LITTLE KIDS',
      href: '/products/smallbirds-wool-runners-little-kids',
      handle: 'smallbirds-wool-runners-little-kids',
    },
    {
      text: 'BIG KIDS',
      href: '/products/smallbirds-wool-runners-big-kids',
      handle: 'smallbirds-wool-runners-big-kids',
    },
  ],
  'smallbirds-wool-runners-big-kids': [
    {
      text: 'LITTLE KIDS',
      href: '/products/smallbirds-wool-runners-little-kids',
      handle: 'smallbirds-wool-runners-little-kids',
    },
    {
      text: 'BIG KIDS',
      href: '/products/smallbirds-wool-runners-big-kids',
      handle: 'smallbirds-wool-runners-big-kids',
    },
  ],
  'smallbirds-wool-loungers-little-kids': [
    {
      text: 'LITTLE KIDS',
      href: '/products/smallbirds-wool-loungers-little-kids',
      handle: 'smallbirds-wool-loungers-little-kids',
    },
    {
      text: 'BIG KIDS',
      href: '/products/smallbirds-wool-loungers-big-kids',
      handle: 'smallbirds-wool-loungers-big-kids',
    },
  ],
  'smallbirds-wool-loungers-big-kids': [
    {
      text: 'LITTLE KIDS',
      href: '/products/smallbirds-wool-loungers-little-kids',
      handle: 'smallbirds-wool-loungers-little-kids',
    },
    {
      text: 'BIG KIDS',
      href: '/products/smallbirds-wool-loungers-big-kids',
      handle: 'smallbirds-wool-loungers-big-kids',
    },
  ],
  'womens-canvas-pacers': [
    { text: 'Womens', href: '/products/womens-canvas-pacers', handle: 'womens-canvas-pacers' },
    { text: 'Mens', href: '/products/mens-canvas-pacers', handle: 'mens-canvas-pacers' },
  ],
  'mens-canvas-pacers': [
    { text: 'Womens', href: '/products/womens-canvas-pacers', handle: 'womens-canvas-pacers' },
    { text: 'Mens', href: '/products/mens-canvas-pacers', handle: 'mens-canvas-pacers' },
  ],
  'womens-wool-runner-2': [
    { text: 'Womens', href: '/products/womens-wool-runner-2', handle: 'womens-wool-runner-2' },
    { text: 'Mens', href: '/products/mens-wool-runner-2', handle: 'mens-wool-runner-2' },
  ],
  'mens-wool-runner-2': [
    { text: 'Womens', href: '/products/womens-wool-runner-2', handle: 'womens-wool-runner-2' },
    { text: 'Mens', href: '/products/mens-wool-runner-2', handle: 'mens-wool-runner-2' },
  ],
  'womens-superlight-wool-runners': [
    {
      text: 'Womens',
      href: '/products/womens-superlight-wool-runners',
      handle: 'womens-superlight-wool-runners',
    },
    {
      text: 'Mens',
      href: '/products/mens-superlight-wool-runners',
      handle: 'mens-superlight-wool-runners',
    },
  ],
  'mens-superlight-wool-runners': [
    {
      text: 'Womens',
      href: '/products/womens-superlight-wool-runners',
      handle: 'womens-superlight-wool-runners',
    },
    {
      text: 'Mens',
      href: '/products/mens-superlight-wool-runners',
      handle: 'mens-superlight-wool-runners',
    },
  ],
  'womens-couriers': [
    { text: 'Womens', href: '/products/womens-couriers', handle: 'womens-couriers' },
    { text: 'Mens', href: '/products/mens-couriers', handle: 'mens-courier' },
  ],
  'mens-couriers': [
    { text: 'Womens', href: '/products/womens-couriers', handle: 'womens-couriers' },
    { text: 'Mens', href: '/products/mens-couriers', handle: 'mens-couriers' },
  ],
  'womens-tree-flyers': [
    { text: 'Womens', href: '/products/womens-tree-flyers', handle: 'womens-tree-flyers' },
    { text: 'Mens', href: '/products/mens-tree-flyers', handle: 'mens-tree-flyers' },
  ],
  'mens-tree-flyers': [
    { text: 'Womens', href: '/products/womens-tree-flyers', handle: 'womens-tree-flyers' },
    { text: 'Mens', href: '/products/mens-tree-flyers', handle: 'mens-tree-flyers' },
  ],
  'womens-vista-racer': [
    { text: 'Womens', href: '/products/womens-vista-racer', handle: 'womens-vista-racer' },
    { text: 'Mens', href: '/products/mens-vista-racer', handle: 'mens-vista-racer' },
  ],
  'mens-vista-racer': [
    { text: 'Womens', href: '/products/womens-tree-flyers', handle: 'womens-tree-flyers' },
    { text: 'Mens', href: '/products/mens-vista-racer', handle: 'mens-vista-racer' },
  ],
  'womens-plant-pacers': [
    { text: 'Womens', href: '/products/womens-plant-pacers', handle: 'womens-plant-pacers' },
    { text: 'Mens', href: '/products/mens-plant-pacers', handle: 'mens-plant-pacers' },
  ],
  'mens-plant-pacers': [
    { text: 'Womens', href: '/products/womens-plant-pacers', handle: 'womens-plant-pacers' },
    { text: 'Mens', href: '/products/mens-plant-pacers', handle: 'mens-plant-pacers' },
  ],
  'womens-risers': [
    { text: 'Womens', href: '/products/womens-risers', handle: 'womens-risers' },
    { text: 'Mens', href: '/products/mens-risers', handle: 'mens-risers' },
  ],
  'mens-risers': [
    { text: 'Womens', href: '/products/womens-risers', handle: 'womens-risers' },
    { text: 'Mens', href: '/products/mens-risers', handle: 'mens-risers' },
  ],
  'womens-superlight-tree-runners': [
    {
      text: 'Womens',
      href: '/products/womens-superlight-tree-runners',
      handle: 'womens-superlight-tree-runners',
    },
    {
      text: 'Mens',
      href: '/products/mens-superlight-tree-runners',
      handle: 'mens-superlight-tree-runners',
    },
  ],
  'mens-superlight-tree-runners': [
    {
      text: 'Womens',
      href: '/products/womens-superlight-tree-runners',
      handle: 'womens-superlight-tree-runners',
    },
    {
      text: 'Mens',
      href: '/products/mens-superlight-tree-runners',
      handle: 'mens-superlight-tree-runners',
    },
  ],
  'womens-canvas-pacer-mids': [
    {
      text: 'Womens',
      href: '/products/womens-canvas-pacer-mids',
      handle: 'womens-canvas-pacer-mids',
    },
    { text: 'Mens', href: '/products/mens-canvas-pacer-mids', handle: 'mens-canvas-pacer-mids' },
  ],
  'mens-canvas-pacer-mids': [
    {
      text: 'Womens',
      href: '/products/womens-canvas-pacer-mids',
      handle: 'womens-canvas-pacer-mids',
    },
    { text: 'Mens', href: '/products/mens-canvas-pacer-mids', handle: 'mens-canvas-pacer-mids' },
  ],
  'womens-wool-pipers': [
    { text: 'Womens', href: '/products/womens-wool-pipers', handle: 'womens-wool-pipers' },
    { text: 'Mens', href: '/products/mens-wool-pipers', handle: 'mens-wool-pipers' },
  ],
  'mens-wool-pipers': [
    { text: 'Womens', href: '/products/womens-wool-pipers', handle: 'womens-wool-pipers' },
    { text: 'Mens', href: '/products/mens-wool-pipers', handle: 'mens-wool-pipers' },
  ],
  'womens-tree-skippers': [
    { text: 'Womens', href: '/products/womens-tree-skippers', handle: 'womens-tree-skippers' },
    { text: 'Mens', href: '/products/mens-tree-skippers', handle: 'mens-tree-skippers' },
  ],
  'mens-tree-skippers': [
    { text: 'Womens', href: '/products/womens-tree-skippers', handle: 'womens-tree-skippers' },
    { text: 'Mens', href: '/products/mens-tree-skippers', handle: 'mens-tree-skippers' },
  ],
  'womens-wool-runner-up-mizzles': [
    {
      text: 'Womens',
      href: '/products/womens-wool-runner-up-mizzles',
      handle: 'womens-wool-runner-up-mizzles',
    },
    {
      text: 'Mens',
      href: '/products/mens-wool-runner-up-mizzles',
      handle: 'mens-wool-runner-up-mizzles',
    },
  ],
  'mens-wool-runner-up-mizzles': [
    {
      text: 'Womens',
      href: '/products/womens-wool-runner-up-mizzles',
      handle: 'womens-wool-runner-up-mizzles',
    },
    {
      text: 'Mens',
      href: '/products/mens-wool-runner-up-mizzles',
      handle: 'mens-wool-runner-up-mizzles',
    },
  ],
  'mens-tree-runner-go': [
    {
      text: 'Womens',
      href: '/products/womens-tree-runner-go',
      handle: 'womens-tree-runner-go',
    },
    {
      text: 'Mens',
      href: '/products/mens-tree-runner-go',
      handle: 'mens-tree-runner-go',
    },
  ],
  'womens-tree-runner-go': [
    {
      text: 'Womens',
      href: '/products/womens-tree-runner-go',
      handle: 'womens-tree-runner-go',
    },
    {
      text: 'Mens',
      href: '/products/mens-tree-runner-go',
      handle: 'mens-tree-runner-go',
    },
  ],
  'mens-superlight-trainers': [
    {
      text: 'Womens',
      href: '/products/womens-superlight-trainers',
      handle: 'womens-superlight-trainers',
    },
    {
      text: 'Mens',
      href: '/products/mens-superlight-trainers',
      handle: 'mens-superlight-trainers',
    },
  ],
  'womens-superlight-trainers': [
    {
      text: 'Womens',
      href: '/products/womens-superlight-trainers',
      handle: 'womens-superlight-trainers',
    },
    {
      text: 'Mens',
      href: '/products/mens-superlight-trainers',
      handle: 'mens-superlight-trainers',
    },
  ],
  'mens-tree-dasher-relay': [
    {
      text: 'Womens',
      href: '/products/womens-tree-dasher-relay',
      handle: 'womens-tree-dasher-relay',
    },
    {
      text: 'Mens',
      href: '/products/mens-tree-dasher-relay',
      handle: 'mens-tree-dasher-relay',
    },
  ],
  'womens-tree-dasher-relay': [
    {
      text: 'Womens',
      href: '/products/womens-tree-dasher-relay',
      handle: 'womens-tree-dasher-relay',
    },
    {
      text: 'Mens',
      href: '/products/mens-tree-dasher-relay',
      handle: 'mens-tree-dasher-relay',
    },
  ],
  'mens-golf-dashers': [
    { text: 'Womens', href: '/products/womens-golf-dashers', handle: 'womens-golf-dashers' },
    { text: 'Mens', href: '/products/mens-golf-dashers', handle: 'mens-golf-dashers' },
  ],
  'womens-golf-dashers': [
    { text: 'Womens', href: '/products/womens-golf-dashers', handle: 'womens-golf-dashers' },
    { text: 'Mens', href: '/products/mens-golf-dashers', handle: 'mens-golf-dashers' },
  ],
  'mens-runner-protect': [
    { text: 'Womens', href: '/products/womens-runner-protect', handle: 'womens-runner-protect' },
    { text: 'Mens', href: '/products/mens-runner-protect', handle: 'mens-runner-protect' },
  ],
  'womens-runner-protect': [
    { text: 'Womens', href: '/products/womens-runner-protect', handle: 'womens-runner-protect' },
    { text: 'Mens', href: '/products/mens-runner-protect', handle: 'mens-runner-protect' },
  ],
  'mens-runner-up-protect': [
    {
      text: 'Womens',
      href: '/products/womens-runner-up-protect',
      handle: 'womens-runner-up-protect',
    },
    { text: 'Mens', href: '/products/mens-runner-up-protect', handle: 'mens-runner-up-protect' },
  ],
  'womens-runner-up-protect': [
    {
      text: 'Womens',
      href: '/products/womens-runner-up-protect',
      handle: 'womens-runner-up-protect',
    },
    { text: 'Mens', href: '/products/mens-runner-up-protect', handle: 'mens-runner-up-protect' },
  ],
  'mens-wool-runner-go': [
    { text: 'Womens', href: '/products/womens-wool-runner-go', handle: 'womens-wool-runner-go' },
    { text: 'Mens', href: '/products/mens-wool-runner-go', handle: 'mens-wool-runner-go' },
  ],
  'womens-wool-runner-go': [
    { text: 'Womens', href: '/products/womens-wool-runner-go', handle: 'womens-wool-runner-go' },
    { text: 'Mens', href: '/products/mens-wool-runner-go', handle: 'mens-wool-runner-go' },
  ],
  'mens-wool-runner-go-fluff': [
    {
      text: 'Womens',
      href: '/products/womens-wool-runner-go-fluff',
      handle: 'womens-wool-runner-go-fluff',
    },
    {
      text: 'Mens',
      href: '/products/mens-wool-runner-go-fluff',
      handle: 'mens-wool-runner-go-fluff',
    },
  ],
  'womens-wool-runner-go-fluff': [
    {
      text: 'Womens',
      href: '/products/womens-wool-runner-go-fluff',
      handle: 'womens-wool-runner-go-fluff',
    },
    {
      text: 'Mens',
      href: '/products/mens-wool-runner-go-fluff',
      handle: 'mens-wool-runner-go-fluff',
    },
  ],
  'mens-tree-toppers': [
    { text: 'Womens', href: '/products/womens-tree-toppers', handle: 'womens-tree-toppers' },
    { text: 'Mens', href: '/products/mens-tree-toppers', handle: 'mens-tree-toppers' },
  ],
  'womens-tree-toppers': [
    { text: 'Womens', href: '/products/womens-tree-toppers', handle: 'womens-tree-toppers' },
    { text: 'Mens', href: '/products/mens-tree-toppers', handle: 'mens-tree-toppers' },
  ],
  'mens-tree-gliders': [
    { text: 'Womens', href: '/products/womens-tree-gliders', handle: 'womens-tree-gliders' },
    { text: 'Mens', href: '/products/mens-tree-gliders', handle: 'mens-tree-gliders' },
  ],
  'womens-tree-gliders': [
    { text: 'Womens', href: '/products/womens-tree-gliders', handle: 'womens-tree-gliders' },
    { text: 'Mens', href: '/products/mens-tree-gliders', handle: 'mens-tree-gliders' },
  ],
  'mens-canvas-pipers': [
    { text: 'Womens', href: '/products/womens-canvas-pipers', handle: 'womens-canvas-pipers' },
    { text: 'Mens', href: '/products/mens-canvas-pipers', handle: 'mens-canvas-pipers' },
  ],
  'womens-canvas-pipers': [
    { text: 'Womens', href: '/products/womens-canvas-pipers', handle: 'womens-canvas-pipers' },
    { text: 'Mens', href: '/products/mens-canvas-pipers', handle: 'mens-canvas-pipers' },
  ],
  'mens-runner-chelsea-protect': [
    {
      text: 'Womens',
      href: '/products/womens-runner-chelsea-protect',
      handle: 'womens-runner-chelsea-protect',
    },
    {
      text: 'Mens',
      href: '/products/mens-runner-chelsea-protect',
      handle: 'mens-runner-chelsea-protect',
    },
  ],
  'womens-runner-chelsea-protect': [
    {
      text: 'Womens',
      href: '/products/womens-runner-chelsea-protect',
      handle: 'womens-runner-chelsea-protect',
    },
    {
      text: 'Mens',
      href: '/products/mens-runner-chelsea-protect',
      handle: 'mens-runner-chelsea-protect',
    },
  ],
  'mens-runner-go-luxe': [
    {
      text: 'Womens',
      href: '/products/womens-runner-go-luxe',
      handle: 'womens-runner-go-luxe',
    },
    {
      text: 'Mens',
      href: '/products/mens-runner-go-luxe',
      handle: 'mens-runner-go-luxe',
    },
  ],
  'womens-runner-go-luxe': [
    {
      text: 'Womens',
      href: '/products/womens-runner-go-luxe',
      handle: 'womens-runner-go-luxe',
    },
    {
      text: 'Mens',
      href: '/products/mens-runner-go-luxe',
      handle: 'mens-runner-go-luxe',
    },
  ],
  'mens-piper-go-luxe': [
    {
      text: 'Womens',
      href: '/products/womens-piper-go-luxe',
      handle: 'womens-piper-go-luxe',
    },
    {
      text: 'Mens',
      href: '/products/mens-piper-go-luxe',
      handle: 'mens-piper-go-luxe',
    },
  ],
  'womens-piper-go-luxe': [
    {
      text: 'Womens',
      href: '/products/womens-piper-go-luxe',
      handle: 'womens-piper-go-luxe',
    },
    {
      text: 'Mens',
      href: '/products/mens-piper-go-luxe',
      handle: 'mens-piper-go-luxe',
    },
  ],
  'mens-wool-piper-go': [
    {
      text: 'Womens',
      href: '/products/womens-wool-piper-go',
      handle: 'womens-wool-piper-go',
    },
    {
      text: 'Mens',
      href: '/products/mens-wool-piper-go',
      handle: 'mens-wool-piper-go',
    },
  ],
  'womens-wool-piper-go': [
    {
      text: 'Womens',
      href: '/products/womens-wool-piper-go',
      handle: 'womens-wool-piper-go',
    },
    {
      text: 'Mens',
      href: '/products/mens-wool-piper-go',
      handle: 'mens-wool-piper-go',
    },
  ],
  'mens-runner-go-corduroy': [
    {
      text: 'Womens',
      href: '/products/womens-runner-go-corduroy',
      handle: 'womens-runner-go-corduroy',
    },
    {
      text: 'Mens',
      href: '/products/mens-runner-go-corduroy',
      handle: 'mens-runner-go-corduroy',
    },
  ],
  'womens-runner-go-corduroy': [
    {
      text: 'Womens',
      href: '/products/womens-runner-go-corduroy',
      handle: 'womens-runner-go-corduroy',
    },
    {
      text: 'Mens',
      href: '/products/mens-runner-go-corduroy',
      handle: 'mens-runner-go-corduroy',
    },
  ],
  'mens-wool-lounger-mule': [
    {
      text: 'Womens',
      href: '/products/womens-wool-lounger-mule',
      handle: 'womens-wool-lounger-mule',
    },
    {
      text: 'Mens',
      href: '/products/mens-wool-lounger-mule',
      handle: 'mens-wool-lounger-mule',
    },
  ],
  'womens-wool-lounger-mule': [
    {
      text: 'Womens',
      href: '/products/womens-wool-lounger-mule',
      handle: 'womens-wool-lounger-mule',
    },
    {
      text: 'Mens',
      href: '/products/mens-wool-lounger-mule',
      handle: 'mens-wool-lounger-mule',
    },
  ],
  'mens-tree-dasher-utility': [
    {
      text: 'Womens',
      href: '/products/womens-tree-dasher-utility',
      handle: 'womens-tree-dasher-utility',
    },
    {
      text: 'Mens',
      href: '/products/mens-tree-dasher-utility',
      handle: 'mens-tree-dasher-utility',
    },
  ],
  'womens-tree-dasher-utility': [
    {
      text: 'Womens',
      href: '/products/womens-tree-dasher-utility',
      handle: 'womens-tree-dasher-utility',
    },
    {
      text: 'Mens',
      href: '/products/mens-tree-dasher-utility',
      handle: 'mens-tree-dasher-utility',
    },
  ],
  'mens-tree-runner-go-utility': [
    {
      text: 'Womens',
      href: '/products/womens-tree-runner-go-utility',
      handle: 'womens-tree-runner-go-utility',
    },
    {
      text: 'Mens',
      href: '/products/mens-tree-runner-go-utility',
      handle: 'mens-tree-runner-go-utility',
    },
  ],
  'womens-tree-runner-go-utility': [
    {
      text: 'Womens',
      href: '/products/womens-tree-runner-go-utility',
      handle: 'womens-tree-runner-go-utility',
    },
    {
      text: 'Mens',
      href: '/products/mens-tree-runner-go-utility',
      handle: 'mens-tree-runner-go-utility',
    },
  ],
};
